import { getCurrentJwt } from "../../../../util/jwt/decryptToken"

export async function fetchAutomations(clientId) {
  const url = process.env.REACT_APP_API_ALT+'/automations'
  const options = {
    method: 'GET',
    headers: {
      Authorization: getCurrentJwt(),
      clientid: clientId
    },
  };
  let sleepTime = 1000
  let res = null
  while (true) {
    try {
      res = await fetch(url, options)
      if(res.status === 200) {
        return await res.json()
      }
      sleepTime *= 2
      await new Promise(resolve => setTimeout(resolve, sleepTime));
    }
    catch (e) {
      console.log(e)
      sleepTime *= 2
      await new Promise(resolve => setTimeout(resolve, sleepTime));
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/dataFetches/fetchAutomations.js